import { render, staticRenderFns } from "./MissionTabs.vue?vue&type=template&id=1fc2dcf2&scoped=true"
import script from "./MissionTabs.vue?vue&type=script&lang=ts"
export * from "./MissionTabs.vue?vue&type=script&lang=ts"
import style0 from "./MissionTabs.vue?vue&type=style&index=0&id=1fc2dcf2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2dcf2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc2dcf2')) {
      api.createRecord('1fc2dcf2', component.options)
    } else {
      api.reload('1fc2dcf2', component.options)
    }
    module.hot.accept("./MissionTabs.vue?vue&type=template&id=1fc2dcf2&scoped=true", function () {
      api.rerender('1fc2dcf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Mission/MissionTabs.vue"
export default component.exports